<template>
  <div class="content2 setmargin">
    <vue-headful
    title="Dashboard | Profiles and Covers"
    description="Dashboard | Profiles and Covers"
/>

<div v-if="loading" style="margin: 0 auto; padding: 70px 0px 0px !important;">
  <center>
  <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
  <p class="lead">Loading...</p>
  </center>
</div>

<div v-if="!loading" class="sc-kAdXeD jwoEpG" style="padding: 40px 0px 0px !important;">
  <div class="sc-bvTASY jPMoWD">
    <div class="mb-4 sinpaddingmobile" style="padding-top: 60px;">
      <h2 class="f342fdw" style="color: #4a5073;">Profiles and Covers</h2>
      <p>Profile and cover images for Facebook, Instagram, LinkedIn, Twitter, YouTube, Etsy, Pinterest, Zoom, and more.</p>
    </div> 
  </div>
  <div class="sc-bvTASY jPMoWD">

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Instagram</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.instagram_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Instagram Profile Photo</h5>
            <p class="small text-gray">(1000x1000)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.instagram_profile_photo_svgcode, 'Instagram-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.instagram_profile_photo_svgcode, 'Instagram-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.instagram_story_photo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Instagram Story Photo</h5>
            <p class="small text-gray">(1080x1920)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.instagram_story_photo_svgcode, 'Instagram-Story-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.instagram_story_photo_svgcode, 'Instagram-Story-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.instagram_post_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Instagram Post Photo</h5>
            <p class="small text-gray">(1080x1080)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.instagram_post_photo_svgcode, 'Instagram-Post-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.instagram_post_photo_svgcode, 'Instagram-Post-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Facebook</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.facebook_cover_image_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Facebook Cover Image</h5>
            <p class="small text-gray">(2460x936)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.facebook_cover_image_svgcode, 'Facebook-Cover-Image')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.facebook_cover_image_svgcode, 'Facebook-Cover-Image')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.facebook_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Facebook Profile Photo</h5>
            <p class="small text-gray">(1500x1500)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.facebook_profile_photo_svgcode, 'Facebook-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.facebook_profile_photo_svgcode, 'Facebook-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">X (Formerly Twitter)</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.x_header_photo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">X Header Photo</h5>
            <p class="small text-gray">(1500x500)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.x_header_photo_svgcode, 'X-Header-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.x_header_photo_svgcode, 'X-Header-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.x_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">X Profile Photo</h5>
            <p class="small text-gray">(800x800)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.x_profile_photo_svgcode, 'X-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.x_profile_photo_svgcode, 'X-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">LinkedIn</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.linkedin_cover_image_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">LinkedIn Cover Image</h5>
            <p class="small text-gray">(1584x396)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.linkedin_cover_image_svgcode, 'LinkedIn-Cover-Image')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.linkedin_cover_image_svgcode, 'LinkedIn-Cover-Image')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.linkedin_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">LinkedIn Profile Photo</h5>
            <p class="small text-gray">(1200x1200)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.linkedin_profile_photo_svgcode, 'LinkedIn-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.linkedin_profile_photo_svgcode, 'LinkedIn-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">YouTube</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.youtube_channel_art_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">YouTube Channel Art</h5>
            <p class="small text-gray">(2048x1152)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.youtube_channel_art_svgcode, 'YouTube-Channel-Art')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.youtube_channel_art_svgcode, 'YouTube-Channel-Art')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.youtube_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">YouTube Profile Photo</h5>
            <p class="small text-gray">(800x800)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.youtube_profile_photo_svgcode, 'YouTube-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.youtube_profile_photo_svgcode, 'YouTube-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">TikTok</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.tiktok_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">TikTok Profile Photo</h5>
            <p class="small text-gray">(800x800)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.tiktok_profile_photo_svgcode, 'TikTok-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.tiktok_profile_photo_svgcode, 'TikTok-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Etsy</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.etsy_cover_image_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Etsy Cover Image</h5>
            <p class="small text-gray">(2990x747)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.etsy_cover_image_svgcode, 'Etsy-Cover-Image')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.etsy_cover_image_svgcode, 'Etsy-Cover-Image')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.etsy_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Etsy Profile Photo</h5>
            <p class="small text-gray">(800x800)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.etsy_profile_photo_svgcode, 'Etsy-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.etsy_profile_photo_svgcode, 'Etsy-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.etsy_shop_photo_base64+'); background-size: contain; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Etsy Shop Photo</h5>
            <p class="small text-gray">(1520x200)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.etsy_shop_photo_svgcode, 'Etsy-Shop-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.etsy_shop_photo_svgcode, 'Etsy-Shop-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">Pinterest</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.pinterest_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Pinterest Profile Photo</h5>
            <p class="small text-gray">(720x720)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.pinterest_profile_photo_svgcode, 'Pinterest-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.pinterest_profile_photo_svgcode, 'Pinterest-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.pinterest_cover_image_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">Pinterest Cover Image</h5>
            <p class="small text-gray">(1200x1200)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.pinterest_cover_image_svgcode, 'Pinterest-Cover-Image')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.pinterest_cover_image_svgcode, 'Pinterest-Cover-Image')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-3 d-flex align-items-center">
      <h4 class="m-0" style="color: #4a5073;">WhatsApp</h4> 
      <div class="flex-grow-1 border-top border-2 ml-3" style="border-color: #e9ebee!important;"></div>
    </div>
    <div class="row">
      <div class="blog-card col-12 col-md-6 col-lg-4">
        <div class="card shadow-soft border-light">
          <div class="card-body px-0" :style="'background-image: url('+files.whatsapp_profile_photo_base64+'); background-size: cover; background-repeat: no-repeat; background-position: center center; height: 300px; border-radius: 0.5rem 0.5rem 0px 0px;background-color: '+logo.background_color+';'">
          </div>
          <div class="card-footer mx-4 px-0">
            <h5 class="mb-2">WhatsApp Profile Photo</h5>
            <p class="small text-gray">(1000x1000)</p>
            <div class="col-12 p-0">
              <button v-if="propsdata[0].canceled === 'yes' || (propsdata[0].paid !== 'yes' && propsdata[0].canceled_due_attempt2 !== 'yes')" class="btn btn-blue w-100" data-toggle="modal" data-target="#modal-profiles-and-covers"> Download </button>
              <button v-else class="btn btn-blue w-100 dropdown-toggle dropdown-toggle-split" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Download </button>
              <div v-if="propsdata[0].paid === 'yes'" class="dropdown-menu w-100 text-center">
                <a @click="downloadPngFile(files.whatsapp_profile_photo_svgcode, 'WhatsApp-Profile-Photo')" class="dropdown-item">PNG</a>
                <a @click="downloadSvgFile(files.whatsapp_profile_photo_svgcode, 'WhatsApp-Profile-Photo')" class="dropdown-item">SVG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Hidden container for SVG processing -->
<div id="svgContainer-edit" class="offscreen"></div>

</div>
</template>

<style>
/* Off-screen CSS */
.offscreen {
  position: absolute;
  visibility: hidden; /* The element is not visible, but it is still rendered */
  width: 1px;         /* Minimize the element size */
  height: 1px;
  overflow: hidden;   /* Ensure that no part of the element spills over */
  left: 0;            /* Position it at the top-left corner to avoid any layout issues */
  top: 0;
}
</style>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  props:['propsdata'],
  data() {
    return {
      timenow: Date.now(),
      loading: true,
      logo_unique_id: '',
      logo: [],
      gradients: {
        '1':{
          'css':'linear-gradient(rgb(23, 234, 217) 0%, rgb(96, 120, 234) 100%)',
          'svg':'<linearGradient id="gradient-1" x1="49.99999999999999%" y1="0%" x2="50.00000000000001%" y2="100%"><stop offset="0.00" stop-color="#17ead9"></stop><stop offset="1.00" stop-color="#6078eb"></stop></linearGradient>'
        },
        '2':{
          'css':'linear-gradient(to top, #09203f 0%, #537895 100%)',
          'svg':'<linearGradient id="gradient-2" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#09203f" />       <stop offset="100%" stop-color="#537895" />     </linearGradient>'
        },
        '3':{
          'css':'linear-gradient(to right, rgb(182, 244, 146), rgb(51, 139, 147))',
          'svg':'<linearGradient id="gradient-3" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="rgb(182, 244, 146)" />       <stop offset="100%" stop-color="rgb(51, 139, 147)" />     </linearGradient>'
        },
        '4':{
          'css':'radial-gradient( circle farthest-corner at 10% 20%,  rgba(14,174,87,1) 0%, rgba(12,116,117,1) 90% )',
          'svg':'<radialGradient id="gradient-4" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(14, 174, 87, 1)" />       <stop offset="90%" stop-color="rgba(12, 116, 117, 1)" />     </radialGradient>'
        },
        '5':{
          'css':'linear-gradient(90deg, rgb(242, 112, 156) 0%, rgb(255, 148, 114) 100%)',
          'svg':'<linearGradient id="gradient-5" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f2709c"></stop><stop offset="1.00" stop-color="#ff9472"></stop></linearGradient>'
        },
        '6':{
          'css':'linear-gradient(90deg, rgb(240, 11, 81) 0%, rgb(115, 0, 98) 100%)',
          'svg':'<linearGradient id="gradient-6" x1="0%" y1="50.00000000000001%" x2="100%" y2="49.99999999999999%"><stop offset="0.00" stop-color="#f00b51"></stop><stop offset="1.00" stop-color="#730062"></stop></linearGradient>'
        },
        '7':{
          'css':'linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)',
          'svg':'<linearGradient id="gradient-7" x1="0%" y1="100%" x2="0%" y2="0%">       <stop offset="0%" stop-color="#a18cd1" />       <stop offset="100%" stop-color="#fbc2eb" />     </linearGradient>'
        },
        '8':{
          'css':'linear-gradient(to right, #ad5389, #3c1053)',
          'svg':'<linearGradient id="gradient-8" x1="0%" y1="0%" x2="100%" y2="0%">       <stop offset="0%" stop-color="#ad5389" />       <stop offset="100%" stop-color="#3c1053" />     </linearGradient>'
        },
        '9':{
          'css':'radial-gradient( circle 860px at 11.8% 33.5%,  rgba(240,30,92,1) 0%, rgba(244,49,74,1) 30.5%, rgba(249,75,37,1) 56.1%, rgba(250,88,19,1) 75.6%, rgba(253,102,2,1) 100.2% )',
          'svg':'<radialGradient id="gradient-9" cx="11.8%" cy="33.5%" r="860px">       <stop offset="0%" stop-color="rgba(240, 30, 92, 1)" />       <stop offset="30.5%" stop-color="rgba(244, 49, 74, 1)" />       <stop offset="56.1%" stop-color="rgba(249, 75, 37, 1)" />       <stop offset="75.6%" stop-color="rgba(250, 88, 19, 1)" />       <stop offset="100.2%" stop-color="rgba(253, 102, 2, 1)" />     </radialGradient>'
        },
        '10':{
          'css':'radial-gradient( circle farthest-corner at 50.4% 50.5%,  rgba(251,32,86,1) 0%, rgba(135,2,35,1) 90% )',
          'svg':'<radialGradient id="gradient-10" cx="50.4%" cy="50.5%" r="100%" fx="50.4%" fy="50.5%">       <stop offset="0%" stop-color="rgba(251, 32, 86, 1)" />       <stop offset="90%" stop-color="rgba(135, 2, 35, 1)" />     </radialGradient>'
        },
        '11':{
          'css':'radial-gradient(489px at 49.3% 46.6%, rgb(255, 214, 126) 0%, rgb(253, 200, 0) 100.2%)',
          'svg':'<radialGradient id="gradient-11" cx="49.3%" cy="46.6%" r="489px">       <stop offset="0%" stop-color="rgb(255, 214, 126)" />       <stop offset="100.2%" stop-color="rgb(253, 200, 0)" />     </radialGradient>'
        },
        '12':{
          'css':'linear-gradient( 109.6deg,  rgba(255,115,68,1) 11.2%, rgba(244,255,32,1) 100.6% )',
          'svg':'<linearGradient id="gradient-12" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(255, 115, 68, 1)" />       <stop offset="100.6%" stop-color="rgba(244, 255, 32, 1)" />     </linearGradient>'
        },
        '13':{
          'css':'linear-gradient( 90.5deg,  rgba(255,207,139,0.50) 1.1%, rgba(255,207,139,1) 81.3% )',
          'svg':'<linearGradient id="gradient-13" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(90.5, 0.5, 0.5)">       <stop offset="1.1%" stop-color="rgba(255, 207, 139, 0.50)" />       <stop offset="81.3%" stop-color="rgba(255, 207, 139, 1)" />     </linearGradient>'
        },
        '14':{
          'css':'linear-gradient( 109.6deg,  rgba(162,2,63,1) 11.2%, rgba(231,62,68,1) 53.6%, rgba(255,129,79,1) 91.1% )',
          'svg':'<linearGradient id="gradient-14" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(162, 2, 63, 1)" />       <stop offset="53.6%" stop-color="rgba(231, 62, 68, 1)" />       <stop offset="91.1%" stop-color="rgba(255, 129, 79, 1)" />     </linearGradient>'
        },
        '15':{
          'css':'radial-gradient( circle farthest-corner at 10% 20%,  rgba(0,95,104,1) 0%, rgba(15,156,168,1) 90% )',
          'svg':'<radialGradient id="gradient-15" cx="10%" cy="20%" r="100%" fx="10%" fy="20%">       <stop offset="0%" stop-color="rgba(0, 95, 104, 1)" />       <stop offset="90%" stop-color="rgba(15, 156, 168, 1)" />     </radialGradient>'
        },
        '16':{
          'css':'linear-gradient( 113.3deg,  rgba(134,209,228,1) -1.8%, rgba(60,80,115,1) 86.4% )',
          'svg':'<linearGradient id="gradient-16" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(113.3, 0.5, 0.5)">       <stop offset="-1.8%" stop-color="rgba(134, 209, 228, 1)" />       <stop offset="86.4%" stop-color="rgba(60, 80, 115, 1)" />     </linearGradient>'
        },
        '17':{
          'css':'linear-gradient( 76.3deg,  rgba(44,62,78,1) 12.6%, rgba(69,103,131,1) 82.8% )',
          'svg':'<linearGradient id="gradient-17" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(76.3, 0.5, 0.5)">       <stop offset="12.6%" stop-color="rgba(44, 62, 78, 1)" />       <stop offset="82.8%" stop-color="rgba(69, 103, 131, 1)" />     </linearGradient>'
        },
        '18':{
          'css':'linear-gradient( 109.6deg,  rgba(20,30,48,1) 11.2%, rgba(36,59,85,1) 91.1% )',
          'svg':'<linearGradient id="gradient-18" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(109.6, 0.5, 0.5)">       <stop offset="11.2%" stop-color="rgba(20, 30, 48, 1)" />       <stop offset="91.1%" stop-color="rgba(36, 59, 85, 1)" />     </linearGradient>'
        },
        '19':{
          'css':'linear-gradient(90deg, #905e25 0%, #f5ec8b 50%, #905e36 100%)',
          'svg':'<linearGradient id="gradient-19"><stop stop-color="#905e25" offset="0"></stop><stop stop-color="#f5ec8b" offset="0.5"></stop><stop stop-color="#905e36" offset="1"></stop></linearGradient>'
        },
        '20':{
          'css':'linear-gradient(90deg, #616162 0%, #e6e7e9 50%, #616162 100%)',
          'svg':'<linearGradient id="gradient-20"><stop stop-color="#616162" offset="0"></stop><stop stop-color="#e6e7e9" offset="0.5"></stop><stop stop-color="#616162" offset="1"></stop></linearGradient>'
        },
        '21':{
          'css':'linear-gradient(to right, #834f3a 0%, #dba174 50%, #834F3A 100%)',
          'svg':'<linearGradient id="gradient-21"><stop stop-color="#834f3a" offset="0"></stop><stop stop-color="#dba174" offset="0.5"></stop><stop stop-color="#834F3A" offset="1"></stop></linearGradient>'
        }
      },
      files: {},
      retry_axios: 1
    };
  },
  methods: {
    downloadSvgFile(svg_code, file_name) {
      // Get the SVG code string from svg_code
      const svgCode = svg_code;

      // Create a Blob from the SVG code
      const blob = new Blob([svgCode], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const downloadLink = document.createElement('a');

      // Set the download attribute with a filename
      downloadLink.download = file_name+'.svg';

      // Set the href attribute to the Blob URL
      downloadLink.href = url;

      // Append the link to the document body (required for Firefox)
      document.body.appendChild(downloadLink);

      // Programmatically click the link to trigger the download
      downloadLink.click();

      // Clean up by removing the link and revoking the Blob URL
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    },
    downloadPngFile(svg_code, file_name) {
      // Create a DOM parser to parse the SVG code
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svg_code, "image/svg+xml");

      // Get the width and height from the SVG element
      const svgElement = svgDocument.documentElement;
      const width = parseInt(svgElement.getAttribute('width'), 10);
      const height = parseInt(svgElement.getAttribute('height'), 10);

      // Create an image element
      const img = new Image();

      // Create a Blob from the SVG code
      const blob = new Blob([svg_code], { type: 'image/svg+xml' });

      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);

      // Set the image source to the Blob URL
      img.src = url;

      // Wait for the image to load
      img.onload = () => {
        // Create a canvas element
        const canvas = document.createElement('canvas');

        // Set the canvas dimensions to the SVG's dimensions
        canvas.width = width;
        canvas.height = height;

        // Draw the image onto the canvas with the specified dimensions
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas to a data URL in PNG format
        const pngUrl = canvas.toDataURL('image/png');

        // Create a temporary link element
        const downloadLink = document.createElement('a');

        // Set the download attribute with a filename
        downloadLink.download = `${file_name}.png`;

        // Set the href attribute to the PNG data URL
        downloadLink.href = pngUrl;

        // Append the link to the document body (required for Firefox)
        document.body.appendChild(downloadLink);

        // Programmatically click the link to trigger the download
        downloadLink.click();

        // Clean up by removing the link and revoking the Blob URL
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
      };
    },
    setNewSvgSizes() {
      // Get the SVG code string from this.logo.svg
      const svgCode = this.logo.svg;

      // Create a DOM parser to parse the SVG string
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(svgCode, "image/svg+xml");

      // Get the original SVG element's viewBox
      const originalSvgElement = svgDocument.documentElement;
      const originalViewBox = originalSvgElement.getAttribute("viewBox");

      // Extract original width and height from viewBox (assuming it's in the format "0 0 width height")
      const [,, originalWidth, originalHeight] = originalViewBox.split(" ").map(Number);

      // Array of size configurations for different platforms
      const sizeConfigs = [
        { name: 'instagram_profile_photo', width: 1000, height: 1000 },
        { name: 'instagram_story_photo', width: 1080, height: 1920 },
        { name: 'instagram_post_photo', width: 1080, height: 1080 },
        { name: 'facebook_cover_image', width: 2460, height: 936 },
        { name: 'facebook_profile_photo', width: 1500, height: 1500 },
        { name: 'x_header_photo', width: 1500, height: 500 },
        { name: 'x_profile_photo', width: 800, height: 800 },
        { name: 'linkedin_cover_image', width: 1584, height: 396 },
        { name: 'linkedin_profile_photo', width: 1200, height: 1200 },
        { name: 'youtube_channel_art', width: 2048, height: 1152 },
        { name: 'youtube_profile_photo', width: 800, height: 800 },
        { name: 'tiktok_profile_photo', width: 800, height: 800 },
        { name: 'etsy_cover_image', width: 2990, height: 747 },
        { name: 'etsy_profile_photo', width: 800, height: 800 },
        { name: 'etsy_shop_photo', width: 1520, height: 200 },
        { name: 'pinterest_profile_photo', width: 720, height: 720 },
        { name: 'pinterest_cover_image', width: 1200, height: 1200 },
        { name: 'whatsapp_profile_photo', width: 1000, height: 1000 }
      ];

      // Loop through each size configuration
      sizeConfigs.forEach(config => {
        // Create a new SVG document with the desired dimensions
        const newSvgDocument = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        newSvgDocument.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        newSvgDocument.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        newSvgDocument.setAttribute("width", config.width);
        newSvgDocument.setAttribute("height", config.height);
        newSvgDocument.setAttribute("viewBox", `0 0 ${config.width} ${config.height}`);

        // Locate the <rect> element for the background (if it exists)
        const backgroundRect = svgDocument.querySelector('rect[data-name="background"]');
        
        // Append the <rect> element to the new SVG document if it exists
        if (backgroundRect) {
          newSvgDocument.appendChild(backgroundRect.cloneNode(true));
        }

        // Calculate the translation values to center the original SVG content
        const translateX = (config.width - originalWidth) / 2;
        const translateY = (config.height - originalHeight) / 2;

        // Create a new <g> element to apply the translation
        const groupElement = document.createElementNS("http://www.w3.org/2000/svg", "g");
        groupElement.setAttribute("transform", `translate(${translateX}, ${translateY})`);

        // Clone the original SVG's children (excluding the <rect>) into the new group element
        Array.from(svgDocument.documentElement.children).forEach(child => {
          if (child !== backgroundRect) {
            groupElement.appendChild(child.cloneNode(true));
          }
        });

        // Append the group element to the new SVG document
        newSvgDocument.appendChild(groupElement);

        // Add the new SVG to the DOM, but keep it hidden
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = '-9999px'; // Hide it offscreen
        document.body.appendChild(container);

        container.appendChild(newSvgDocument);

        // Access the <g> element that wraps the logo content and calculate its bounding box
        const logoGroupElement = newSvgDocument.querySelector('g');
        if (logoGroupElement) {
          const boundingBox = logoGroupElement.getBBox();
          const logoWidth = boundingBox.width;
          const logoHeight = boundingBox.height;

          // Log the width and height of the logo
          // console.log(`Logo Width: ${logoWidth}, Logo Height: ${logoHeight}`);

          // Apply the scaling to make the logo 70% of the new SVG size
          const scaleFactor = Math.min(0.7 * config.width / logoWidth, 0.7 * config.height / logoHeight);
          const scaledTranslateX = (config.width - logoWidth * scaleFactor) / 2 - boundingBox.x * scaleFactor;
          const scaledTranslateY = (config.height - logoHeight * scaleFactor) / 2 - boundingBox.y * scaleFactor;
          logoGroupElement.setAttribute('transform', `translate(${scaledTranslateX}, ${scaledTranslateY}) scale(${scaleFactor})`);
        }

        // Serialize the new SVG document back to a string
        const serializer = new XMLSerializer();
        const updatedSvgCode = serializer.serializeToString(newSvgDocument);

        // Save the updated SVG code string
        this.files[`${config.name}_svgcode`] = updatedSvgCode;

        // Encode the updated SVG code to Base64
        const base64Svg = btoa(encodeURIComponent(updatedSvgCode).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          return String.fromCharCode('0x' + p1);
        }));

        // Save the base64 encoded SVG into corresponding files object
        this.files[`${config.name}_base64`] = `data:image/svg+xml;base64,${base64Svg}`;

        // Clean up the DOM by removing the offscreen container
        document.body.removeChild(container);
      });
    }
  },
  mounted() {
    this.logo_unique_id = this.$route.params.logo_unique_id;
    this.$emit('updatepath');
    axios.post('/dashboard/get-logo-data.php', {
      unique_id: this.logo_unique_id
    })
    .then(response => {
      if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
        this.retry_axios = this.retry_axios+1;
        this.propsdata[0].saving_logo = false;
        this.choose_logo(object);
      }
      else if(response.data === 'logo not found'){
        this.$router.push('/dashboard/get-profiles-and-covers/'); //redirect to select brand
      }
      else{
        this.retry_axios = 1;
        this.logo = response.data;
        this.setNewSvgSizes();
        this.loading = false;
      }
    })
    .catch(function (error) {
      console.log(error);
      this.retry_axios = 1;
    });
  },
  // do not forget this section
directives: {
ClickOutside
}
};
</script>



// WEBPACK FOOTER //
// src/profiles-and-covers.vue